import React from 'react';

interface ChevronDownIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({
  width = 26,
  height = 15,
  color = '#fff',
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.573713 0.58066C-0.191075 1.34541 -0.191075 2.58543 0.573713 3.35016L10.1543 12.9213C11.6841 14.4496 14.163 14.449 15.692 12.9201L25.2689 3.3431C26.0338 2.57838 26.0338 1.33836 25.2689 0.573591C24.5041 -0.191197 23.2641 -0.191197 22.4994 0.573591L14.3026 8.77043C13.5379 9.53536 12.2978 9.53516 11.5331 8.77043L3.34321 0.58066C2.57844 -0.184128 1.33848 -0.184128 0.573713 0.58066Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronDownIcon;
